export const fil = {
    translation: {
        common: {
            trial: "Bersyong Pagsubok",
            expired: "Lipas na",
            renewal: "Pag-renew",
            quantity: "Dami",
            error: "Error",
            all: "Lahat",
            loading: "Naglo-load...",
            thank_you: "Salamat",
            confirm: "Kumpirmahin",
            cancel: "I-cancel",
            save: "I-save",
            add: "Idagdag",
            edit: "I-edit",
            delete: "Burahin",
            warning: "Babala",
            delete_confirm_text: "Hindi na mababawi ang aksyong ito. Sigurado ka bang gusto mong burahin?",
            click_to_select: "Pumili...",
            unit: "Yunit",
            detail: "Detalye",
            done: "Tapos na",
            search: "Maghanap",
            processing: "Pinoproseso...",
            success: "Tagumpay",
            total: "Kabuuan",
            none: "Wala"
        },
        roles: {
            admin: "Admin",
            barista: "Barista",
            waiter: "Waiter",
            kitchen: "Kusina"
        },
        auth: {
            user_not_found: "Hindi mahanap ang user!",
            welcome: "Maligayang Pagbabalik",
            subtitle: "Mag-sign in para pamahalaan ang iyong coffee shop",
            google_login: "Mag-sign in gamit ang Google",
            apple_login: "Mag-sign in gamit ang Apple",
            secure_login: "Secure Login",
            terms_text: "Sa pag-sign in, sumasang-ayon ka sa aming Mga Tuntunin ng Serbisyo at Patakaran sa Privacy."
        },
        sidebar: {
            dashboard: "Dashboard",
            tables: "Mga Mesa",
            staff: "Mga Staff",
            loyalty: "CRM at Loyalty",
            qr_menu: "QR Menu",
            menu_product: "Menu at Produkto",
            stock_recipe: "Stock at Resipe",
            reports: "Mga Report",
            settings: "Mga Setting",
            admin_panel: "Admin Panel",
            not_logged_in: "Hindi Naka-login",
            click_to_select: "Pumili ng Profile",
            switch_profile: "Magpalit ng Profile",
            logout: "Logout"
        },
        dashboard: {
            overview: "Overview ng Dashboard",
            today: "Ngayong Araw",
            system_active: "Aktibo ang System",
            offline: "Offline Mode",
            payment_reminder: "Paalala sa Bayad",
            payment_missing_list: "Ang bayad para sa {{names}} ay hindi pa nagagawa.",
            add_expense: "Magdagdag ng Gastos",
            daily_revenue: "Kita Ngayong Araw",
            open_tables: "Mga Bukas na Mesa",
            pending_tables: "Mga Nakabinbing Order",
            waiting_approval: "Naghihintay ng Aprubal",
            active_staff: "Aktibong Staff",
            hourly_revenue: "Kita Bawat Oras",
            hourly_profit: "Tubo Bawat Oras",
            work_hours: "Oras ng Trabaho",
            hours_24: "24 Oras",
            revenue: "Kita",
            profit: "Tubo",
            best_sellers: "Pinakamabenta",
            support_modal: { other: "Iba pa" },
            weekly_performance: "Performance Ngayong Linggo",
            weekly_revenue: "Kita Ngayong Linggo",
            increase: "Pagtaas",
            decrease: "Pagbaba",
            busiest_day: "Pinaka-abalang Araw",
            view_report: "Tignan ang Report",
            critical_stock_warning: "Kritikal na Stock",
            quick_actions: "Mabilisang Aksyon",
            x_report: "X Report",
            sync: "I-sync",
            backup: "Backup",
            support: "Suporta",
            help_support: "Tulong at Suporta",
            help_desc: "Paano ka namin matutulungan?",
            report_issue: "I-report ang Problema",
            version: "Bersyon",
            topic: "Paksa",
            technical: "Teknikal na Problema",
            suggestion: "Suhestyon",
            other: "Iba pa",
            description: "Deskripsyon",
            desc_placeholder: "Pakilarawan ang problema...",
            send_report: "Ipadala ang Report"
        },
        tables: {
            status: {
                occupied: "May Tao",
                paid: "Bayad na",
                reserved: "Reserved",
                empty: "Bakante"
            },
            alerts: {
                reservation_time: "Oras ng Reserbasyon:",
                draft_paid: "Bayad na Draft Order",
                draft_unpaid: "Draft Order"
            },
            title: "Plano ng Mesa",
            tabs: {
                plan: "Plano",
                history: "Kasaysayan"
            },
            filter: {
                all: "Lahat"
            },
            actions: {
                finish_edit: "Tapusin ang Pag-edit",
                edit: "I-edit ang mga Mesa",
                add_table: "Magdagdag ng Mesa",
                quick_pay: "Mabilis na Bayad",
                reserve: "I-reserve",
                clear: "Linisin"
            },
            card: {
                capacity: "Tao",
                just_now: "Ngayon lang",
                total: "Kabuuan",
                has_request: "Bagong Request",
                no_order: "Walang Order"
            },
            history: {
                search_placeholder: "Maghanap ng Ticket No o Mesa...",
                multi_pay: "Multi Pay"
            },
            sections: {
                manage: "Pamahalaan ang mga Seksyon",
                add_placeholder: "Pangalan ng Bagong Seksyon",
                no_sections: "Walang tinukoy na mga seksyon."
            },
            modal: {
                edit_title: "I-edit ang Mesa",
                add_title: "Magdagdag ng Mesa",
                name: "Pangalan ng Mesa",
                name_placeholder: "hal. Mesa 5",
                section: "Seksyon",
                capacity: "Kapasidad",
                delete: "Burahin ang Mesa",
                unpaid_warning_title: "May Hindi pa Bayad!",
                clear_confirm_title: "Linisin ang Mesa?",
                unpaid_warning_text: "Ang <b>{{name}}</b> ay may hindi pa bayad na balanse. Ang paglilinis nito ay magre-reset ng order.",
                clear_confirm_text: "Sigurado ka bang gusto mong linisin ang <b>{{name}}</b>?",
                delete_confirm_text: "Sigurado ka bang gusto mong burahin ang <b>{{name}}</b>?"
            },
            qr_review: {
                title: "Darating na QR Order",
                subtitle: "Bagong request mula sa {{name}}",
                current_state: "Kasalukuyang Estado ng Mesa",
                table_empty: "Bakante ang mesa sa kasalukuyan.",
                current_total: "Kasalukuyang Kabuuan",
                incoming_request: "Darating na Request",
                extra_total: "Dagdag na Kabuuan",
                reject: "Tanggihan",
                overwrite: "Palitan Lahat",
                overwrite_desc: "Linisin ang kasalukuyan at ilagay ang bago",
                merge: "Pagsamahin",
                merge_desc: "Idagdag sa kasalukuyang order"
            }
        },
        orders: {
            status: {
                completed: "Tapos na"
            },
            list: {
                ticket_no: "Ticket No",
                date: "Petsa/Oras",
                table: "Mesa/Customer",
                method: "Paraan",
                amount: "Halaga",
                status: "Status"
            },
            modal: {
                match_error: "Ang kabuuang bayad ({{pay}}₺) ay hindi tugma sa kabuuan ng order ({{total}}₺).",
                title: "Mga Detalye ng Transaksyon",
                content_title: "Nilalaman ng Order",
                total_title: "Kabuuang Halaga",
                payment_details: "Mga Detalye ng Bayad",
                entered_total: "Inilagay na Kabuuan",
                difference: "Pagkakaiba"
            },
            correction: {
                note_placeholder: "hal. maling entry ng staff"
            },
            void_flow: {
                button_update: "I-update ang Status / Void",
                button_void: "Void / Refund",
                title_select: "Pumili ng Uri ng Void",
                type_cancel: "Error / Pagbabalik",
                type_cancel_desc: "Ibinabalik ang Stock",
                type_wastage: "Wastage / Natapon",
                type_wastage_desc: "Ibabawas sa Stock (Walang Balik)",
                confirm_cancel_title: "I-marka bilang Error/Pagbabalik",
                confirm_wastage_title: "I-marka bilang Wastage",
                confirm_cancel_text: "Ika-kansela nito ang benta at ibabalik ang lahat ng stock. Sigurado ka ba?",
                confirm_wastage_text: "Ika-kansela nito ang benta pero ang stock ay ituturing na GAMIT NA/NAWALA. Sigurado ka ba?",
                confirm: "KUMPIRMAHIN"
            }
        },
        pos: {
            title_quick: "Mabilisang Order",
            title_no_table: "Walang Mesa",
            title_table: "{{name}}",
            search_placeholder: "Maghanap ng Produkto...",
            grid: {
                sold_out: "UBOS NA"
            },
            ticket: {
                title: "Kasalukuyang Ticket",
                order_no: "ORDER NO",
                new: "BAGO",
                empty: "Walang laman ang cart.",
                status: {
                    wastage: "WASTAGE",
                    comp: "LIBRE",
                    cancelled: "KINANSELA",
                    paid: "BAYAD NA"
                },
                discount_badge: "OFF"
            },
            actions: {
                discount: "DISCOUNT",
                comp: "LIBRE",
                void: "WASTAGE",
                cancel: "I-CANCEL",
                pay: "BAYAD",
                assign_table: "MESA",
                save: "I-SAVE",
                waiting_payment: "HINIHINTAY ANG BAYAD",
                close_ticket: "ISARA ANG TICKET"
            },
            totals: {
                subtotal_net: "Subtotal (Net)",
                tax_vat: "Buwis (VAT)",
                grand_total: "Kabuuang Halaga",
                tax_exclusive_hint: "(+Buwis)"
            },
            alerts: {
                table_not_found: "Hindi mahanap ang mesa.",
                perm_comp: "Wala kang pahintulot na magbigay ng libreng item.",
                perm_void: "Wala kang pahintulot na mag-void ng mga item.",
                select_item_error: "Pumili muna ng item.",
                paid_item_error: "Ang mga bayad na item ay hindi na maaaring baguhin.",
                split_quantity: "Ilan sa {{count}} na item ang ililipat?",
                invalid_amount: "Maling halaga.",
                perm_discount: "Wala kang pahintulot na mag-apply ng discount.",
                select_discount_item: "Pumili ng item na lalagyan ng discount.",
                paid_discount_error: "Hindi pwedeng lagyan ng discount ang mga bayad na item.",
                add_items_first: "Magdagdag muna ng mga item sa cart.",
                unauthorized: "Access Denied"
            },
            modifier_modal: {
                no_modifiers: "Walang available na modifier.",
                multiple: "maramihan",
                add_to_cart: "Idagdag sa Cart"
            },
            discount_modal: {
                title: "Mag-apply ng Discount",
                percent: "Porsyento",
                amount: "Halaga",
                comp_100: "LIBRE (100%)",
                old_total: "Lumang Kabuuan",
                new_total: "Bagong Kabuuan",
                apply: "I-apply ang Discount"
            }
        },
        payment: {
            alerts: {
                enter_valid: "Mangyaring magpasok ng tamang halaga.",
                balance_not_zero: "Ang natitirang balanse ay dapat 0 para maisara ang ticket."
            },
            header_order: "Order",
            header_open: "Buksan ang Ticket",
            ticket_details: "Mga Detalye ng Ticket",
            select_all: "Piliin Lahat",
            items_count: "{{count}} (na) Item",
            empty_list: "Walang Item",
            remaining_badge: "Tira: {{amount}}",
            recent_transactions: "MGA RECENT NA TRANSAKSYON",
            totals: {
                total: "Kabuuan",
                paid: "Bayad na",
                remaining: "Natitira"
            },
            amount_to_collect: "Halagang Kolektahin",
            give_change: "Sukli",
            return_to_customer: "Ibalik sa Customer",
            methods: {
                cash: "Cash",
                card: "Credit Card",
                qr: "QR / Mobile",
                other: "Meal Card"
            },
            numpad: {
                all: "Lahat"
            },
            actions: {
                cancel: "I-cancel",
                close_ticket: "Isara ang Ticket",
                waiting_payment: "Hinihintay ang Bayad"
            }
        },
        menu: {
            title: "Pamamahala ng Menu",
            subtitle: "Pamahalaan ang mga produkto, presyo, at stock",
            add_new: "Magdagdag ng Produkto",
            edit_title: "I-edit ang Produkto",
            add_title: "Magdagdag ng Produkto",
            manage_categories: "Pamahalaan ang mga Kategorya",
            alerts: {
                no_permission: "Wala kang pahintulot na pamahalaan ang menu.",
                delete_confirm: "Sigurado ka bang gusto mong burahin ang produktong ito?"
            },
            form: {
                image_select: "Pumili ng Larawan",
                image_change: "Palitan ang Larawan",
                image_recommendation: "Inirerekomenda ang square format",
                image_max_size: "Max 2MB",
                name: "Pangalan ng Produkto",
                name_placeholder: "hal. Latte",
                category: "Kategorya",
                price: "Presyo",
                stock_tracking: "Pagsubaybay sa Stock",
                stock_hint: "Iwanang 0 para i-disable",
                description: "Deskripsyon",
                description_placeholder: "Mga sangkap, detalye...",
                customizable: "Nababago (Modifiers)"
            },
            categories: {
                title: "Pamamahala ng Kategorya",
                add: "Magdagdag ng Kategorya",
                name: "Pangalan ng Kategorya",
                edit: "I-edit ang Kategorya",
                delete_confirm: "Burahin ang kategoryang ito?"
            }
        },
        categories: {
            all: "Lahat",
            hot_coffees: "Mainit na Kape",
            cold_coffees: "Malamig na Kape",
            desserts: "Mga Dessert",
            snacks: "Mga Snack",
            barista_special: "Espesyal"
        },
        stock: {
            title: "Pamamahala ng Inventory",
            subtitle: "Stock, mga Resipe, at Modifiers",
            tabs: {
                inventory: "Inventory",
                recipes: "Mga Resipe",
                modifiers: "Modifiers"
            },
            inventory: {
                total_value: "Kabuuang Halaga",
                sku_count: "Bilang ng SKU",
                alerts: "Mga Alert sa Stock",
                search_placeholder: "Maghanap sa Stock...",
                add_stock: "Magdagdag ng Item",
                status_critical: "Kritikal",
                status_warning: "Mababa na",
                status_sufficient: "OK",
                table: {
                    name: "Pangalan",
                    supplier: "Supplier",
                    amount: "Dami",
                    status: "Status",
                    unit_cost: "Halaga bawat Yunit",
                    actions: "Mga Aksyon"
                },
                modal: {
                    edit_title: "I-edit ang Stock",
                    add_title: "Magdagdag ng Stock",
                    general_info: "Pangkalahatang Impormasyon",
                    management: "Pamamahala",
                    name: "Pangalan ng Item",
                    name_placeholder: "hal. Gatas",
                    supplier: "Supplier",
                    supplier_placeholder: "hal. Lokal na Bukid",
                    unit: "Yunit",
                    alarm_thresholds: "Alarm Thresholds",
                    warning_limit: "Warning Limit",
                    critical_limit: "Kritikal na Limit",
                    stock_status: "Status ng Stock",
                    finish_editing: "Tapusin ang Pag-edit",
                    manual_correction: "Manwal na Pagwawasto",
                    current_amount: "Kasalukuyang Dami",
                    unit_cost: "Halaga bawat Yunit",
                    new_purchase: "Bagong Bili / Entry",
                    add_amount: "Magdagdag ng Dami",
                    purchase_price: "Presyo ng Pagbili",
                    total: "Kabuuan",
                    unit_price: "Presyo bawat Yunit",
                    success_feedback: "Na-update na!",
                    calculate_add: "Kalkulahin at Idagdag",
                    avg_cost_note: "* Kinakalkula ang weighted average cost."
                }
            },
            wastage: {
                title: "I-report ang Wastage",
                subtitle: "Nagre-report ng wastage para sa {{name}}",
                amount: "Dami",
                reason: "Dahilan",
                reason_placeholder: "hal. Natapon, Nasira",
                report: "Ipadala ang Report"
            },
            recipes: {
                search_product: "Maghanap ng produkto...",
                gross_margin: "Gross Margin",
                sale_price: "Presyo ng Benta",
                cost_price: "Halaga ng Gastos",
                ingredients: "Mga Sangkap",
                no_recipe: "Walang tinukoy na resipe.",
                add_ingredient: "Magdagdag ng Sangkap",
                stock_item: "Stock Item",
                amount: "Dami",
                unit: "Yunit"
            },
            modifiers: {
                title: "Mga Grupo ng Modifier",
                new_group: "Bagong Grupo",
                group_name: "Pangalan ng Grupo",
                selection_type: "Uri ng Pagpili",
                single: "Isa lang (Radio)",
                multiple: "Maramihan (Checkbox)",
                options: "Mga Opsyon",
                option_name: "Pangalan ng Opsyon",
                option_placeholder: "hal. Oat Milk",
                extra_price: "Dagdag na Presyo",
                deduct_stock: "Ibawas sa Stock (Opsyonal)",
                add_option: "Magdagdag ng Opsyon",
                group_helper_text: "Pamahalaan ang mga opsyon para sa grupong ito sa ibaba.",
                no_link: "Walang Link",
                stock_optional_label: "Stock (Opsyonal)",
                edit_group_title: "I-edit ang Grupo",
                allow_multiple_label: "Payagan ang maramihang pagpili (Checkbox)",
                delete_group_confirm: "Sigurado ka bang gusto mong burahin ang grupong ito?"
            }
        },
        reports: {
            title: "Overview ng Pinansyal",
            filters: { today: "Ngayong Araw", week: "Linggo", month: "Buwan", all: "Lahat" },
            kpi: {
                revenue: "Kabuuang Kita",
                net_revenue: "Netong Kita (Walang Buwis)",
                tax_collected: "Buwis na Nakolekta",
                income: "Pumasok na Pera",
                expense: "Kabuuang Gastos",
                expense_opr: "Operational",
                expense_stock: "COGS",
                expense_wastage: "Wastage",
                profit: "Netong Tubo",
                profit_opr: "Operating Profit",
                cash_in_hand: "Cash Flow",
                gross_profit: "Gross Profit",
                tickets: "Kabuuang Ticket",
                sales_count: "Bilang ng Benta",
                expense_analysis: "Pagsusuri ng Gastos",
                profit_analysis: "Pagsusuri ng Netong Tubo",
                available_in_standard: "Available sa Standard Plan",
                locked: "Naka-lock"
            },
            toggles: {
                stock_cost: "Halaga ng Stock",
                wastage: "Wastage",
                operational: "Operational Mode",
                net_revenue: "Netong Kita (Buwis)"
            },
            charts: {
                sales_title: "Chart ng Benta ({{currency}})",
                hourly: "Bawat Oras",
                daily: "Araw-araw",
                monthly: "Buwanan",
                distribution: "Distribusyon",
                category_breakdown: "Hati bawat Kategorya",
                revenue_share: "Hati sa Kita",
                no_data: "Walang data.",
                tooltip_revenue: "Kita: ",
                tooltip_net_revenue: "Netong Kita: ",
                tooltip_profit: "Tubo: "
            },
            transactions: {
                title: "Kasaysayan ng Transaksyon",
                count_listed: "{{count}} (na) Record ang Nakalista",
                table: {
                    ticket_no: "Ticket No",
                    date: "Petsa / Oras",
                    table: "Mesa",
                    method: "Paraan",
                    amount: "Halaga",
                    status: "Status"
                },
                status: {
                    completed: "Tapos na",
                    cancelled: "Kinansela"
                },
                no_records: "Walang nahanap na transaksyon sa napiling petsa."
            },
            x_report: {
                title: "Ulat ng Cash (X-Report)",
                total_cash: "Kabuuang Cash sa Cashier",
                daily_tickets: "Mga Ticket Ngayong Araw",
                cancelled_trx: "Mga Kinanselang Transaksyon",
                collections: "Mga Koleksyon (Kasalukuyan)",
                shift_reports: "Staff Shift Reports (Ngayon)",
                no_shift: "Wala pang shift reports.",
                total_sales: "KABUUANG BENTA",
                cash: "Cash",
                credit_card: "Credit Card",
                qr_mobile: "QR / Mobile",
                meal_card: "Meal Card"
            },
            z_report: {
                title: "Ulat sa Katapusan ng Araw (Z-Report)",
                auto_toggle: "Auto Z-Report",
                auto_desc: "Tuwing 00:00",
                close_button: "ISARA ANG ARAW (Z-REPORT)",
                history_title: "Mga Nakaraang Z-Report",
                no_reports: "Wala pang report.",
                receipt: {
                    title: "Z REPORT",
                    report_no: "Report No",
                    cashier: "Cashier",
                    total_sales: "KABUUANG BENTA",
                    tax_base: "Tax Base",
                    total_tax: "Kabuuang Buwis",
                    payment_details: "Mga Detalye ng Bayad",
                    cash: "Cash",
                    card: "Credit Card",
                    other: "Iba pa",
                    end: "--- WAKAS ---"
                }
            },
            modals: {
                close_confirm: {
                    title: "Isasara na ang Araw?",
                    text: "I-aarchive nito ang <strong>{{count}}</strong> na bukas na transaksyon at gagawa ng opisyal na Z-Report. Hindi na ito mababawi.",
                    cancel: "I-cancel",
                    confirm: "Kumpirmahin at Isara"
                },
                expense: {
                    title: "Mabilis na Pagdagdag ng Gastos",
                    date: "Petsa",
                    category: "Kategorya",
                    amount: "Halaga",
                    description: "Deskripsyon",
                    optional: "Opsyonal...",
                    set_default: "I-set bilang default para sa kategorya",
                    last_trx: "Huli: {{amount}} ({{date}})"
                },
                processing: {
                    title: "Gumagawa ng Z-Report...",
                    text: "Mangyaring maghintay, pinoproseso ang katapusan ng araw..."
                }
            },
            liabilities: {
                pending: "Mga Nakabinbing Bayad",
                label_today: "Hati sa Gastos Ngayon",
                label_week: "Hati sa Gastos Ngayong Linggo",
                label_total: "Nakabinbing Recurring Payments"
            }
        },
        settings: {
            general: "Pangkalahatang Setting",
            titles: {
                general: "Pangkalahatan",
                expenses: "Mga Gastos",
                modifiers: "Modifiers",
                developer: "Developer"
            },
            descriptions: {
                general: "Setting ng system, wika, at negosyo",
                expenses: "Konpigurasyon ng pinansyal",
                developer: "Mga tool para sa simulation at testing"
            },
            subscription: {
                active: "AKTIBO",
                inactive: "HINDI AKTIBO",
                expired: "EXPIRED",
                renew: "I-renew",
                days_left: "Mga Araw na Natitira",
                next_payment: "Susunod na Bayad",
                period_start: "Simula ng Period",
                time_remaining: "Natitirang Oras",
                lite_plan: "Lite Plan",
                standard_plan: "Standard Plan"
            },
            business_identity: "Identidad ng Negosyo",
            financial: "Setting ng Pinansyal",
            financial_desc: {
                currency_desc: "Simbolo na gagamitin sa system",
                pricing_desc: "Paraan ng pag-kalkula ng buwis"
            },
            interface: {
                title: "Interface",
                scale: "UI Scale (Zoom)",
                scale_desc: "I-adjust ang scale para sa mga item na hindi kasya o masyadong maliit/malaki.",
                note: "Tandaan:",
                scale_note: "Ang auto-scaling ay laging aktibo sa mga screen na mas maliit sa 1366px."
            },
            operational: {
                title: "Oras ng Trabaho at Shift",
                start_hour: "Oras ng Simula (0-23)",
                end_hour: "Oras ng Tapos (0-23)",
                info_text: "Ang setting na ito ang tumutukoy sa oras na ipapakita sa **Dashboard** hourly sales chart kapag pinili ang 'Oras ng Trabaho'. Ginagamit din ito bilang basehan para sa shift reporting ng staff.",
                updated_alert: "Na-update na ang oras ng trabaho."
            },
            shortcuts: {
                staff_desc: "Pamahalaan ang mga Waiter, Barista, at Admin"
            },
            backup: {
                title: "Data at Backup",
                backup_now: "I-backup",
                backup_desc: "I-download ang Database (.json)",
                restore: "I-restore",
                restore_desc: "Pumili ng .json na File",
                factory_reset: "Factory Reset",
                reset_desc: "Lahat ng data ay mabubura at babalik sa dating estado.",
                reset_button: "I-reset ang Data",
                success_restore: "Matagumpay na na-restore ang backup."
            },
            security: {
                reset_title: "Factory Reset",
                restore_title: "I-restore mula sa Backup",
                reset_text: "Hindi na mababawi ang aksyong ito. Lahat ng data (benta, produkto, stock) ay permanenteng mabubura.",
                restore_text: "Mabubura ang kasalukuyang data at ikakarga ang data mula sa napiling backup file.",
                admin_required: "Kailangan ng Aprubal ng Admin",
                enter_pin: "Pakipasok ang PIN",
                confirm_reset: "Burahin at I-reset",
                confirm_restore: "Simulan ang Pag-restore"
            },
            messages: {
                updated: "Na-update na ang mga setting.",
                error: "May naganap na error."
            },
            sync: {
                title: "Cloud Sync",
                pending: "{{count}} (na) nakabinbing item",
                up_to_date: "Lahat ng data ay updated",
                button: "I-sync Ngayon"
            }
        },
        financials: {
            title: "Setting ng Pinansyal",
            subtitle: "Tax Rates at mga Kategorya ng Gastos",
            tabs: {
                taxes: "Mga Buwis",
                expenses: "Mga Gastos",
                history: "Kasaysayan ng Gastos"
            },
            taxes: {
                title: "Tax Rates",
                active_rates: "Aktibong Rates",
                rate_name: "Pangalan ng Rate",
                rate_percent: "Rate %",
                description: "Deskripsyon",
                add_new: "Magdagdag ng Bagong Rate",
                category_mapping: "Category Tax Mapping"
            },
            expenses: {
                title: "Mga Kategorya ng Gastos",
                add_new: "Magdagdag ng Kategorya",
                category_name: "Pangalan ng Kategorya",
                description: "Deskripsyon",
                default_amount: "Default na Halaga",
                recurring: "Recurring (Buwanan)",
                recurring_day: "Araw ng Buwan",
                distribute_daily: "I-distribute araw-araw sa mga report"
            },
            history: {
                title: "Kasaysayan ng Gastos",
                filter_all: "Lahat ng Kategorya",
                no_records: "Walang nahanap na record.",
                table: {
                    date: "Petsa",
                    category: "Kategorya",
                    description: "Deskripsyon",
                    amount: "Halaga"
                }
            }
        },
        crm: {
            title: "CRM at Loyalty",
            subtitle: "Pamamahala ng Customer at Loyalty Program",
            give_points: "Magbigay ng Points",
            qr_instruction: "I-scan ang QR code ng customer",
            generate_qr: "Gumawa ng QR",
            qr_description: "Ipakita ang QR code na ito sa customer para magdagdag ng points sa kanilang wallet.",
            customer_list: "Listahan ng Customer",
            search_placeholder: "Maghanap ng Customer...",
            last_visit: "Huling Bisita:",
            eligible: "May Reward na Pwedeng Makuha!",
            settings_title: "Setting ng Campaign",
            target_points: "Target na Points",
            reward_name: "Pangalan ng Reward",
            preview: "Preview ng Card",
            target_label: "Target",
            coming_soon: "Malapit na"
        },
        qr: {
            title: "QR Menu",
            subtitle: "Digital Menu at Ordering System",
            simulate: "Simulahin ang Order",
            print_selected: "I-print ang Napili",
            lock: {
                title: "Naka-lock ang Online Services",
                desc: "Ang QR Menu at online ordering ay available sa Standard Plan.",
                upgrade_btn: "Mag-upgrade ng Plan"
            },
            print: {
                title: "I-print ang mga QR Code",
                scan_instruction: "I-scan para makita ang Menu"
            },
            preview: {
                title: "Live Preview",
                network: "Network:",
                password: "Pass:",
                powered_by: "Powered by KahveInn",
                disclaimer: "* Ito ay preview ng magiging hitsura ng QR stand.",
                scan_instruction: "I-scan para sa Menu"
            },
            settings: {
                general: "Pangkalahatan",
                active: "Aktibo",
                active_desc: "I-enable ang QR Menu system",
                ordering: "Payagan ang Pag-order",
                ordering_desc: "Ang mga customer ay pwedeng mag-order",
                sound: "Sound Alert",
                sound_desc: "Mag-play ng tunog sa bagong order",
                design: "Disenyo",
                header_text: "Header Text",
                theme_color: "Theme Color",
                wifi_ssid: "Wi-Fi SSID",
                wifi_pass: "Wi-Fi Password"
            },
            selection: {
                title: "Pagpili ng Mesa",
                select_all: "Piliin Lahat",
                previewing: "Nire-review"
            },
            modal: {
                permission_title: "Kailangan ng Pahintulot",
                permission_text: "Kailangan namin ng pahintulot sa browser para mag-play ng sound notification.",
                allow_btn: "Payagan ang Tunog"
            }
        },
        staff: {
            title: "Pamamahala ng Staff",
            subtitle: "Mga empleyado at awtorisasyon",
            tabs: {
                list: "Listahan ng Staff",
                roles: "Mga Role at Pahintulot"
            },
            lite_banner: {
                title: "Lite Plan",
                desc: "Ang advanced staff management ay limitado."
            },
            stats: {
                total: "Kabuuang Staff",
                on_duty: "Naka-duty"
            },
            matrix: {
                person: "Tao"
            },
            auto_shift_report: "Auto Shift Report",
            modal: {
                add_title: "Magdagdag ng Staff",
                edit_title: "I-edit ang Staff",
                delete: "Burahin ang Staff",
                name: "Buong Pangalan",
                role: "Role",
                pin: "PIN Code (4-digits)",
                phone: "Telepono (Opsyonal)",
                status: "Status",
                status_working: "Nagtatrabaho",
                status_off: "Off Duty"
            },
            roles_tab: {
                title: "Mga Role",
                subtitle: "I-customize ang mga pahintulot ng role",
                permissions: "Mga Pahintulot",
                no_permissions: "Walang itinalagang pahintulot"
            },
            contact: "Kontak",
            status: {
                working: "Nagtatrabaho",
                offline: "Off Duty"
            },
            permission_matrix: "Matrix ng Pahintulot",
            no_pin_permission: "Walang pahintulot na makita/baguhin ang PIN",
            unauthorized_tooltip: "Hindi mo maaaring i-edit ang user na ito",
            alerts: {
                no_add_permission: "Wala kang pahintulot na magdagdag ng staff.",
                no_edit_others: "Sarili mong profile lang ang pwede mong i-edit.",
                no_edit_admin: "Mga Admin lang ang pwedeng mag-edit ng Admin.",
                no_delete_self: "Hindi mo pwedeng burahin ang sarili mo.",
                no_delete_permission: "Wala kang pahintulot na magbura ng staff.",
                no_delete_admin: "Mga Admin lang ang pwedeng magbura ng Admin.",
                delete_confirm: "Sigurado ka bang gusto mong burahin ang staff na ito?",
                no_status_admin: "Mga Admin lang ang pwedeng magbago ng status ng Admin.",
                only_admin_roles: "Mga Admin lang ang pwedeng magbago ng mga pahintulot ng role."
            }
        },
        permission_groups: {
            general: "Pangkalahatan",
            sales: "Benta",
            management: "Pamamahala"
        },
        permissions: {
            VIEW_FINANCIALS: { label: "Tignan ang Pinansyal", description: "Access sa data ng kita at tubo" },
            VIEW_TABLES: { label: "Tignan ang mga Mesa", description: "Tignan ang plano ng mesa at mga order" },
            MANAGE_MENU: { label: "Pamahalaan ang Menu", description: "Magdagdag at mag-edit ng mga produkto" },
            MANAGE_STOCK: { label: "Pamahalaan ang Stock", description: "Kontrol sa inventory" },
            VIEW_REPORTS: { label: "Tignan ang mga Report", description: "Access sa mga pahina ng report" },
            MANAGE_STAFF: { label: "Pamahalaan ang Staff", description: "Magdagdag/magbura ng staff" },
            MANAGE_SETTINGS: { label: "Pamahalaan ang mga Setting", description: "Konpigurasyon ng system" },
            VOID_ITEM: { label: "Void na Item", description: "Mga operasyon ng cancel o wastage" },
            OFFER_COMP: { label: "Magbigay ng Libre", description: "Pahintulot na magbigay ng libreng item" },
            APPLY_DISCOUNT: { label: "Mag-apply ng Discount", description: "Mag-apply ng discount sa order" },
            CLOSE_DAY: { label: "Isara ang Araw", description: "Pahintulot na kumuha ng Z-Report" }
        },
        setup: {
            business_name: "Pangalan ng Negosyo",
            business_address: "Address",
            manager_name: "Pangalan ng Manager",
            manager_hint: "Ang iyong pangalan para sa manager profile",
            staff_count: "Bilang ng Staff",
            staff_hint: "Tantiyang bilang ng mga empleyado",
            currency: "Pera (Currency)",
            pricing_model: "Modelo ng Pagpepresyo",
            tax_inclusive: "Kasama ang Buwis",
            tax_exclusive: "Hindi Kasama ang Buwis",
            completing: "Tinatapos ang Setup...",
            title_1: "Maligayang Pagdating",
            title_2: "Team at Pamamahala",
            title_3: "Setting ng Pinansyal",
            desc_1: "Gawin natin ang identidad ng iyong negosyo.",
            desc_2: "I-configure natin ang istraktura ng iyong team.",
            desc_3: "Piliin ang iyong pera at mga kagustuhan sa buwis.",
            skip_dev: "Laktawan (Dev)",
            back: "Bumalik",
            next: "Susunod",
            finish: "Tapusin ang Setup",
            placeholders: {
                business_name: "hal. KahveInn",
                city: "Lungsod (hal. Quezon City)",
                district: "Distrito (hal. Diliman)",
                address_detail: "Kalye, Numero ng Gusali...",
                manager_name: "Iyong Buong Pangalan"
            },
            errors: {
                business_name: "Mangyaring ilagay ang pangalan ng negosyo.",
                city: "Mangyaring ilagay ang lungsod.",
                district: "Mangyaring ilagay ang distrito.",
                address_detail: "Mangyaring ilagay ang buong address.",
                manager_name: "Mangyaring ilagay ang pangalan ng manager.",
                staff_count: "Mangyaring ilagay ang tamang bilang ng staff."
            },
            currencies: {
                try: "Turkish Lira (₺)",
                usd: "$ - US Dollar ($)",
                eur: "Euro (€)",
                gbp: "Pound Sterling (£)"
            },
            loading_text: "Inihahanda na ang iyong system, mangyaring maghintay."
        }
    }
};